import { createRouter, createWebHistory } from 'vue-router';
import { isLogin, setUserLastRequestUrl, checkIsShowFullPage } from '../functions/apis-pages/login.js';
import HomeView from '../views/HomeView.vue';
import { isJumpToWechatLogin, isInWechatApp } from '@/functions/apis-pages/wechatSDKJs.js';
import { userIntercept } from '@/functions/apis-pages/pages/userIntercept.js';
import { updatePaymentParentsKeepAliveForPurchaseNotes } from '@/utils/keepAlivePurchaseNotesParents';

const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta: {
    }
  },
  {
    path: '/about',   //关于我们
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  // {
  //   path: '/',
  //   name: 'myHome',  //首页
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: () => import('../views/MyHome.vue')
  // },
  {
    path: '/',
    // path: '/newHome',
    name: 'newHome',  //首页
    // meta: {
    //   requireAuth: true
    // },
    component: () => import('../views/NewHome.vue')
  },
  {
    //  path: '/',
    path: '/newHomeCopy',
    name: 'newHomeCopy',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/NewHomeCopy.vue')
  },
  // {
  //   path: '/',
  //   name: 'download',  // 同downloadApp页面
  //   component: () => import('../views/Download.vue')
  // },
  {
    path: '/indexnew',
    name: 'index',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/IndexnewView.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      requireAuth: false
    },
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/setPayPassword', //设置支付密码
    name: 'setPayPassword',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/SetPayPassword.vue')
  },
  {
    path: '/messageList', //消息 列表
    name: 'messageList',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MessageList.vue')
  },
  {
    path: '/set',   //设置
    name: 'set',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/SetView.vue')
  },
  {
    path: '/realName',   //实名认证
    name: 'realName',
    component: () => import(/* webpackChunkName: "about" */ '../views/RealName.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/account',   //账户余额
    name: 'account',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/AccountView.vue')
  },
  {
    path: '/mine',   //我的
    name: 'mine',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/MineView.vue')
  },
  {
    path: '/cart',   //购物车列表
    name: 'cart',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/ShoppingCart.vue')
  },
  {
    path: '/auctionMarket',   //拍卖市场
    name: 'auctionMarket',
    component: () => import(/* webpackChunkName: "about" */ '../views/AuctionMarket.vue')
  },
  {
    path: '/auctionDetail',   //拍卖详情
    name: 'auctionDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/AuctionDetail.vue')
  },
  {
    path: '/myLand',   //我的土地
    name: 'myLand',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/MyLand.vue')
  },
{
    path: '/newMyLand',   //我的土地
    name: 'newMyLand',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/NewMyLand.vue')
  },
  
  {
    path: '/map',   //地图
    name: 'map',
    component: () => import(/* webpackChunkName: "about" */ '../views/MapView.vue')
  },
  {
    path: '/inviteFriends',   //邀请好友
    name: 'inviteFriends',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/InviteFriends.vue')
  },
  {
    path: '/changePhone',   //修改手机号
    name: 'changePhone',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/ChangePhone.vue')
  },
  {
    path: '/contactUs',   //联系我们
    name: 'contactUs',
    component: () => import('../views/ContactUs.vue')
  },
  {
    path: '/licenseAgreement',   //许可协议
    name: 'licenseAgreement',
    component: () => import('../views/LicenseAgreement.vue')
  },
  {
    path: '/privacyPolicy',   //隐私政策
    name: 'privacyPolicy',
    component: () => import('../views/PrivacyPolicy.vue')
  },
  {
    path: '/accountDetail',   //账户明细
    name: 'accountDetail',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/AccountDetail.vue')
  },
  {
    path: '/payment',   //支付/充值/提现页面
    name: 'payment',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/PaymentView.vue')
  },
  {
    path: '/paySuccess',   //支付/充值/提现成功
    name: 'paySuccess',
    // meta: {
    //   requireAuth: true
    // },
    component: () => import('../views/PaySuccess.vue')
  },
  {
    path: '/payFailure',   //支付/充值/提现失败
    name: 'payFailure',
    // meta: {
    //   requireAuth: true
    // },
    component: () => import('../views/PayFailure.vue')
  },
  {
    path: '/payResult',   //支付/充值/提现失败
    name: 'payResult',
    // meta: {
    //   requireAuth: true
    // },
    component: () => import('../views/PayResult.vue')
  },
  
  {
    path: '/editProfile',   //修改头像昵称等
    name: 'editProfile',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/EditProfile.vue')
  },
  {
    path: '/editNickname',   //修改昵称
    name: 'editNickname',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/EditNickname.vue')
  },
  {
    path: '/editIntro',   //修改个人简介
    name: 'editIntro',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/EditIntro.vue')
  },
  {
    path: '/contactDetail',   //联系我们
    name: 'contactDetail',
    component: () => import('../views/ContactDetail.vue')
  },
  {
    path: '/platformIntro',   //平台介绍
    name: 'platformIntro',
    component: () => import('../views/PlatformIntro.vue')
  },
  {
    path: '/testDon',   // 测试
    name: 'testDon',
    component: () => import('../views/Test/TestView.vue')
  },
  {
    path: '/buyActivity', // 购买活动排名
    name: 'buyActivity',
    component: () => import('../views/BuyActivity.vue')
  },
  {
    path: '/digitalCollectionDetails', // 数藏详情页
    name: 'digitalCollectionDetails',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/DigitalCollectionDetails.vue')
  },
  {
    path: '/digitalCollection', // 数藏首页
    name: 'digitalCollection',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/DigitalCollection.vue')
  },
  {
    path: '/myDigitalCollection', // 我的藏品
    name: 'myDigitalCollection',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyDigitalCollection.vue')
  },
  {
    path: '/myDigitalCollectionDetails', // 我的藏品详情
    name: 'myDigitalCollectionDetails',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyDigitalCollectionDetails.vue')
  },
  {
    path: '/collectionsAirdrop', // 藏品空投
    name: 'collectionsAirdrop',
    component: () => import('../views/CollectionsAirdrop.vue')
  },
  {
    path: '/downloadApp', // APP下载
    name: 'downloadApp',
    component: () => import('../views/DownloadApp.vue')
  },
    {
    path: '/downloadDianzhenaiApp', // APP下载
    name: 'downloadDianzhenaiApp',
    component: () => import('../views/DownloadDianzhenaiApp.vue')
  },
  {
    path: '/download', // APP下载
    name: 'download',
    component: () => import('../views/Download.vue')
  },
  {
    path: '/report',   // 投诉页面
    name: 'report',
    component: () => import('../views/Report/ReportView.vue')
  },
  {
    path: '/collectFragments', // 收集藏品
    name: 'collectFragments',
    component: () => import('../views/CollectFragments.vue')
  },
  {
    path: '/buildingComplex', // 收集藏品
    name: 'buildingComplex',
    component: () => import('../views/BuildingComplex.vue')
  },
  {
    path: '/buildingComplexDetails', // 数藏详情页
    name: 'buildingComplexDetails',
    component: () => import('../views/BuildingComplexDetails.vue')
  },
  {
    path: '/myBuildingComplex', // 我的建筑、土地列表
    name: 'myBuildingComplex',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyBuildingComplex.vue')
  },
  {
    path: '/myBuildingComplexDetails', // 我的建筑、土地列表详情
    name: 'myBuildingComplexDetails',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyBuildingComplexDetails.vue')
  },
  {
    path: '/aiDemo',   // AI demo页面
    name: 'aiDemo',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/AiDemo.vue')
  },

  {
    path: '/coCreationCommunity', // 共创首页
    name: 'coCreationCommunity',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/CoCreationCommunity.vue')
  },
  {
    path: '/coCreationCommunityDetails', // 共创详情页
    name: 'coCreationCommunityDetails',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/CoCreationCommunityDetails.vue')
  },
  {
    path: '/electricity', // 电力值
    name: 'electricity',
    component: () => import('../views/Electricity.vue')
  },
  {
    path: '/powerValueDetail', // 电力值明细
    name: 'powerValueDetail',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/PowerValueDetail.vue')
  },

  {
    path: '/myCoCreationCommunity', // 我的共创
    name: 'myCoCreationCommunity',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyCoCreationCommunity.vue')
  },
  // {
  //   path: '/myCoCreationCommunity', // 我的共创
  //   name: 'myCoCreationCommunity',
  //   component: () => import('../views/MyCoCreationCommunity.vue')
  // },
  // {
  //   path: '/myCoCreationCommunityDetails', // 我的共创详情
  //   name: 'myCoCreationCommunityDetails',
  //   component: () => import('../views/MyCoCreationCommunityDetails.vue')
  // },
  {
    path: '/dianCoin', // 电力值
    name: 'dianCoin',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/DianCoin.vue')
  },
  {
    path: '/myEarnings',
    name: 'myEarnings',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyEarnings.vue')
  },
  {
    path: '/gw-product', // 电力值
    name: 'gw-product',
    component: () => import('../views/GwProduct.vue')
  },
  {
    path: '/discover', // 发现
    name: 'discover',
    component: () => import('../views/Discover.vue')
  },
  {
    path: '/friends', // 好友
    name: 'friends',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/Friends.vue')
  },

  {
    path: '/landSaleList', // 热卖土列表页面
    name: 'landSaleList',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/LandSaleList.vue')
  },

  {
    path: '/BruceLeeCard', // 李小龙卡牌
    name: 'BruceLeeCard',
    component: () => import('../views/BruceLeeCard.vue')
  },

  {
    path: '/addressEdit', // 地址编辑页
    name: 'addressEdit',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/AddressEdit.vue')
  },
  {
    path: '/myCard', // 我的卡牌
    name: 'myCard',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyCardLists.vue')
  },
  {
    path: '/myCardDetails', // 我的卡牌
    name: 'myCardDetails',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyCardDetails.vue')
  },
  {
    path: '/cardSeries', // 系列卡牌
    name: 'cardSeries',
    component: () => import('../views/CardSeries.vue')
  },
  {
    path: '/cardSeriesList', // 系列卡牌列表
    name: 'cardSeriesList',
    component: () => import('../views/CardSeriesList.vue')
  },
  {
    path: '/cardSeriesListDetails', // 系列卡牌列表 下的某一个系列详情
    name: 'cardSeriesListDetails',
    component: () => import('../views/CardSeriesListDetails.vue')
  },
  {
    path: '/myCardSeriesDetails', // 我的单张数字卡
    name: 'myCardSeriesDetails',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyCardSeriesListDetailsDetails.vue')
  },
  {
    path: '/cardSeriesDetails', // 单张数字卡详情说明
    name: 'cardSeriesDetails',
    component: () => import('../views/CardSeriesDetails.vue')
  },
  {
    path: '/physicalCard', // 系列卡牌 （实体）
    name: 'physicalCard',
    component: () => import('../views/PhysicalCard.vue')
  },
  {
    path: '/physicalCardList', // 系列卡牌 （实体）单个系列下的列表
    name: 'physicalCardList',
    component: () => import('../views/PhysicalCardList.vue')
  },
  {
    path: '/physicalCardDetails', // 系列卡牌 （实体）详情
    name: 'physicalCardDetails',
    component: () => import('../views/PhysicalCardDetails.vue')
  },
  {
    path: '/gzq2024', // 点真星球 × 2024 格子旗音乐节嘉年华
    name: 'gzq2024',
    component: () => import('../views/Gzq2024.vue')
  },
  {
    path: '/surname', // 点真星球 × 姓氏元宇宙
    name: 'surname',
    component: () => import('../views/Surname.vue')
  },
  {
    path: '/cardSeriesListForSurname', // 系列卡牌列表
    name: 'cardSeriesListForSurname',
    component: () => import('../views/CardSeriesListForSurname.vue')
  },
  {
    path: '/shippedList',   // 发货列表页
    name: 'shippedList',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/ShippedList.vue')
  },
  {
    path: '/deliverGoodsList', // 发货列表
    name: 'deliverGoodsList',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/DeliverGoodsList.vue')
  },
  {
    path: '/myDeliverGoodsDetail', // 发货详情页面
    name: 'myDeliverGoodsDetail',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyDeliverGoodsDetail.vue')
  },
  {
    path: '/ticket', // 点真星球 × 刮刮乐
    name: 'ticket',
    component: () => import('../views/Ticket.vue')
  },
  {
    path: '/cardSeriesListForSurnameEntity', // 系列卡牌列表
    name: 'cardSeriesListForSurnameEntity',
    component: () => import('../views/CardSeriesListForSurnameEntity.vue')
  },
  {
    path: '/arScan', // Kivi AR扫一扫
    name: 'arScan',
    component: () => import('../views/ArScan.vue')
  },
  {
    path: '/verify',   // 验伪页面
    name: 'verify',
    component: () => import('../views/Verify.vue')
  },
  {
    path: '/xnfd', // 点真星球 × 姓氏元宇宙
    name: 'xnfd',
    component: () => import('../views/Xnfd.vue')
  },
  {
    path: '/landList',
    name: 'landList',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/LandList.vue')
  },
  {
    path: '/AiQA',
    name: 'AiQA',
    // meta: {
    //   requireAuth: true
    // },
    component: () => import('../views/AiQA.vue')
  },
  {
    path: '/aiRewardRank',
    name: 'aiRewardRank',
    component: () => import('../views/AiRewardRank.vue')
  },
  {
    path: '/landDetails',
    name: 'landDetails',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/LandDetails.vue')
  },
  {
    path: '/purchaseNotes', // 购买须知
    name: 'purchaseNotes',
    component: () => import('../views/PurchaseNotes.vue')
  },
  {
    path: '/referralDistributionAgreement', // 点真AI推荐官分销服务协议
    name: 'referralDistributionAgreement',
    component: () => import('../views/ReferralDistributionAgreement.vue')
  },
  {
    path: '/square', // 发现广场
    name: 'square',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/Square.vue')
  },
  {
    path: '/mall', // iframe 嵌入式页面 通用模版
    name: 'mall',
    component: () => import('../views/Mall.vue')
  },
  {
    path: '/aiSpace', // iframe 嵌入式页面 通用模版
    name: 'aiSpace',
    component: () => import('../views/AiSpace.vue')
  },
  {
    path: '/aiFeed', // AI投喂
    name: 'aiFeed',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/AiFeed.vue')
  },
  {
    path: '/editAiFeed', // AI信息投喂核心问题编辑页面
    name: 'editAiFeed',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/EditAiFeed.vue')
  },
  {
    path: '/photoTool', // 文生图
    name: 'photoTool',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/PhotoTool.vue')
  },
  {
    path: '/videoTool', // 文生视频
    name: 'videoTool',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/VideoTool.vue')
  },
  {
    path: '/videoGenerate', // 生成视频
    name: 'videoGenerate',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/VideoGenerate.vue')
  },
  {
    path: '/shortDramaGenerate', // 一句话生成短剧
    name: 'shortDramaGenerate',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/ShortDramaGenerate.vue')
  },
  {
    path: '/photoAnimate', // 照片动起来
    name: 'photoAnimate',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/PhotoAnimate.vue')
  },
  {
    path: '/realTimeVoice', // 实时语音
    name: 'realTimeVoice',
    meta: {
      // requireAuth: true
    },
    component: () => import('../views/RealTimeVoice.vue')
  },
  {
    path: '/aiAgentList', // 智能体列表
    name: 'aiAgentList',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/AiAgentList.vue')
  },
  {
    path: '/myAiAgents', // 我的 AI 智能体
    name: 'myAiAgents',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyAiAgents.vue')
  },
  {
    path: '/myCards', // 我的 AI 名片
    name: 'myCards',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyCards.vue')
  },
  {
    path: '/cardEdit/:id?', // 创建 / 编辑名片
    name: 'cardEdit',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/CardEdit.vue')
  },
  {
    path: '/card/:publicId', // 公开名片页（免登录，已登录用户也可访问预览）
    name: 'cardDetail',
    meta: {
      requireAuth: false,
      allowLoggedIn: true
    },
    component: () => import('../views/CardDetail.vue')
  },
  {
    path: '/aiAgentDetail', // 智能体详情页
    name: 'aiAgentDetail',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/AiAgentDetail.vue')
  },
  {
    path: '/aiAgentEdit', // 创建 / 编辑智能体
    name: 'aiAgentEdit',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/AiAgentEdit.vue')
  },
  {
    path: '/aiAgentImage', // AI 形象设置
    name: 'aiAgentImage',
    meta: {
      requireAuth: true,
      // title: 'AI形象',
    },
    component: () => import('../views/AiAgentImage.vue')
  },
  {
    path: '/aiAgentBrand', // AI 品牌资料
    name: 'aiAgentBrand',
    meta: {
      requireAuth: true,
      // title: '品牌资料',
    },
    component: () => import('../views/AiAgentBrand.vue')
  },
  {
    path: '/aiAgentContact', // AI 联系方式
    name: 'aiAgentContact',
    meta: {
      requireAuth: true,
      // title: '联系方式',
    },
    component: () => import('../views/AiAgentContact.vue')
  },
  {
    path: '/aiAgentProduct', // AI 商品/服务
    name: 'aiAgentProduct',
    meta: {
      requireAuth: true,
      // title: '商品/服务',
    },
    component: () => import('../views/AiAgentProduct.vue')
  },
  {
    path: '/aiAgentCase', // AI 案例作品
    name: 'aiAgentCase',
    meta: {
      requireAuth: true,
      // title: '案例作品',
    },
    component: () => import('../views/AiAgentCase.vue')
  },
  {
    path: '/aiAgentKnowledge', // AI 知识问答
    name: 'aiAgentKnowledge',
    meta: {
      requireAuth: true,
      // title: '知识问答',
    },
    component: () => import('../views/AiAgentKnowledge.vue')
  },
  {
    path: '/aiAgentMemory', // AI 记忆管理
    name: 'aiAgentMemory',
    meta: {
      requireAuth: true,
      // title: '记忆管理',
    },
    component: () => import('../views/AiAgentMemory.vue')
  },
  {
    path: '/aiAgentPlan', // AI 生成方案预览
    name: 'aiAgentPlan',
    meta: {
      requireAuth: true,
      // title: 'AI生成方案'
    },
    component: () => import('../views/AiAgentPlan.vue')
  },
  {
    path: '/aiAgentIdentity', // AI 身份选择
    name: 'aiAgentIdentity',
    meta: {
      requireAuth: true,
    },
    component: () => import('../views/AiAgentIdentity.vue')
  },
  {
    path: '/aiAgentPersona', // AI 身份人设训练
    name: 'aiAgentPersona',
    meta: {
      requireAuth: true,
      // title: '身份人设',
    },
    component: () => import('../views/AiAgentPersona.vue')
  },
  {
    path: '/aiAgentModules', // AI 能力模块
    name: 'aiAgentModules',
    meta: {
      requireAuth: true,
    },
    component: () => import('../views/AiAgentModules.vue')
  },
  {
    path: '/aiAgentPosterAssistant', // 海报生成助手
    name: 'aiAgentPosterAssistant',
    meta: {
      requireAuth: true,
    },
    component: () => import('../views/AiAgentPosterAssistant.vue')
  },
  {
    path: '/aiAgentXhsCopyAssistant', // 小红书文案助手
    name: 'aiAgentXhsCopyAssistant',
    meta: {
      requireAuth: true,
    },
    component: () => import('../views/AiAgentXhsCopyAssistant.vue')
  },
  {
    path: '/aiAgentLogoAssistant', // LOGO 生成助手
    name: 'aiAgentLogoAssistant',
    meta: {
      requireAuth: true,
    },
    component: () => import('../views/AiAgentLogoAssistant.vue')
  },
  {
    path: '/aiAgentFineTune', // 微调 AI 智能体
    name: 'aiAgentFineTune',
    meta: {
      requireAuth: true,
      // title: '微调AI智能体'
    },
    component: () => import('../views/AiAgentFineTune.vue')
  },
  {
    path: '/aiAgentReport', // AI 智能体日报 / 月报
    name: 'aiAgentReport',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/AiAgentReport.vue')
  },
  {
    path: '/voiceCall', // 实时语音
    name: 'voiceCall',
    meta: {
      // requireAuth: true
    },
    component: () => import('../views/VoiceCall.vue')
  },
  {
    path: '/userReport', // 举报
    name: 'userReport',
    component: () => import('../views/UserReport.vue')
  },
  {
    path: '/myLock', // 我的锁定
    name: 'myLock',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/MyLock.vue')
  },
  // {
  //   path: '/myHome', //新首页
  //   name: 'myHome',
  //   component: () => import('../views/MyHome.vue')
  // },
  {
    path: '/historyRecord', // 历史
    name: 'historyRecord',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/HistoryRecord.vue')
  },
  {
    path: '/getCoordinates', // 获取坐标
    name: 'getCoordinates',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/GetCoordinates.vue')
  },
    {
    path: '/newGetCoordinates', // 碰碰运气新 ui
    name: 'newGetCoordinates',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/NewGetCoordinates.vue')
  },
  {
    path: '/newGetCoordinates2', // 碰碰运气新 ui
    name: 'newGetCoordinates2',
    component: () => import('../views/NewGetCoordinates2.vue')
  },
  {
    path: '/operateManual', // 操作手册
    name: 'operateManual',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/OperateManual.vue')
  },
  {
    path: '/customerServiceQa', // 客服答疑类（智能体配置说明）
    name: 'customerServiceQa',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/CustomerServiceQa.vue')
  },
  {
    path: '/rolePlaying', // 角色扮演类（智能体配置说明）
    name: 'rolePlaying',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/RolePlaying.vue')
  },
  {
    path: '/copywriting', // 文案撰写类（智能体配置说明）
    name: 'copywriting',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/Copywriting.vue')
  },
  {
    path: '/promptTutorial', // 提示词教程
    name: 'promptTutorial',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/PromptTutorial.vue')
  },

  {
    path: '/getDclaw', // 获取小龙虾
    name: 'getDclaw',
    // meta: {
    //   requireAuth: false
    // },
    component: () => import('../views/GetDclaw.vue')
  },
   {
    path: '/getDclawNew', // 新的宣发页
    name: 'getDclawNew',
    meta: {
      title: '',
    },
    component: () => import('../views/GetDclawNew.vue')
  },
  {
    path: '/getDclawReferral', // 推荐官计划 H5（文案排版见副本完整版）
    name: 'getDclawReferral',
    component: () => import('../views/GetDclawReferralH5.vue')
  },
  {
    path: '/getDclawAgent', // 代理级别计划 H5
    name: 'getDclawAgent',
    component: () => import('../views/GetDclawAgentH5.vue')
  },
  {
    path: '/identityBenefits', // 身份权益说明
    name: 'identityBenefits',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/IdentityBenefits.vue')
  },
  {
    path: '/userPublicProfile', // 别人查看你的主页（公开预览）
    name: 'userPublicProfile',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/UserPublicProfile.vue')
  },
  {
    path: '/userPublicAiList', // 查看他人 AI 智能体/账号列表
    name: 'userPublicAiList',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/UserPublicAiList.vue')
  },
  {
    path: '/sharePoster', // 分享海报
    name: 'sharePoster',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/SharePoster.vue')
  },
  {
    path: '/sharePartnerPoster', // 合伙人邀请海报
    name: 'sharePartnerPoster',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/SharePartnerPoster.vue')
  },

  {
    path: '/coordinatesShare', // 分享
    name: 'coordinatesShare',
    component: () => import('../views/CoordinatesShare.vue')
  },
  {
    path: '/getActivityPower', // 活动
    name: 'getActivityPower',
    component: () => import('../views/GetActivityPower.vue')
  },
  {
    path: '/searchCoordinates', // 搜索坐标
    name: 'searchCoordinates',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/SearchCoordinates.vue')
  },
  {
    path: '/coordinatesShow', // 坐标首页
    name: 'coordinatesShow',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/CoordinatesShow.vue')
  },
  {
    path: '/newCoordinatesShow',
    name: 'newCoordinatesShow',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/NewCoordinatesShow.vue')
  },
  {
    path: '/markdownParser', // MarkdownParser.vue
    name: 'markdownParser',
    component: () => import('../views/MarkdownParser.vue')
  },
  {
    path: '/sbti-personality-test',
    name: 'sbtiPersonalityTest',
    meta: {
      title: 'SBTI人格测试',
      requireAuth: true
    },
    component: () => import('../views/SbtiPersonalityTest.vue')
  },
  {
    path: '/inviteCode', // 邀请码输入独立页面
    name: 'inviteCode',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/InviteCode.vue')
  },
  {
    path: '/aiCoordinates',   // AI账号
    name: 'aiCoordinates',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/AiCoordinates.vue')
  },
  {
    path: '/rankingList',   // 排行榜
    name: 'rankingList',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/RankingList.vue')
  },
  {
    path: '/applyServiceProvider',   // 服务商签约申请付款页面
    name: 'applyServiceProvider',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/ApplyServiceProvider.vue')
  },
  {
    path: '/uploadPpt', // 上传 PPT（规范：ppt/pptx/pdf，<20MB）
    name: 'uploadPpt',
    meta: {
      requireAuth: true,
      // title: '上传PPT',
    },
    component: () => import('../views/UploadPpt.vue')
  },
  {
    path: '/xingyunAvatar', // 星云具身驱动（实时数字人）
    name: 'xingyunAvatar',
    meta: {
      requireAuth: true,
      // title: '具身驱动讲PPT',
    },
    component: () => import('../views/XingyunAvatar.vue')
  },
  {
    path: '/aiAgentTrain', // AI 智能体训练 Hub
    name: 'aiAgentTrain',
    meta: {
      requireAuth: true,
      // title: 'AI智能体训练',
    },
    component: () => import('../views/AiAgentTrain.vue')
  },
  {
    path: '/aiAgentSpecialTrain', // AI 智能体训练（对话/专项）
    name: 'aiAgentSpecialTrain',
    meta: {
      requireAuth: true,
      // title: 'AI智能体训练',
    },
    component: () => import('../views/AiAgentSpecialTrain.vue')
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});
function beforeRouterEach(to, from, next) {
  const isShowFullPage = checkIsShowFullPage(to, next);
  if (typeof isShowFullPage == 'boolean' && false === isShowFullPage) {
    return;
  }
  if (!userIntercept(to, next)) {
    return;
  }
  setUserLastRequestUrl(to);
  if (
    typeof to == 'object' && null != to &&
    typeof to.meta == 'object' && null != to.meta &&
    typeof to.meta.requireAuth == 'boolean'
  ) {
    if (to.meta.requireAuth && !isLogin()) {
      // 必须登录, 跳转到登录
      next('/login');
      return;
    } else if (!to.meta.requireAuth && isLogin() && to.meta.allowLoggedIn !== true) {
      // 登录以后，不能访问该页面 (如已经登录了，就不应该在访问登录页面)
      next('/');
      return;
    }
  }
  next();
  return;
}
router.beforeEach((to, from, next) => {
  updatePaymentParentsKeepAliveForPurchaseNotes(to, from);
  isInWechatApp(() => {
    if (isJumpToWechatLogin(to, next)) {
      return;
    }
    beforeRouterEach(to, from, next);
  }, () => {
    beforeRouterEach(to, from, next);
  });
});

/**
 * 同步当前 H5 地址到小程序壳
 * 微信的「收藏」「添加到我的小程序」只保存小程序页面路径，web-view 内部的 H5 路由不会带进去，
 * 导致从收藏再次打开时落到首页或上一次的页面。这里每次路由变化后把当前地址上报给小程序，
 * 小程序壳层收到后持久化，再在场景值 1010（收藏夹）打开时还原到正确页面。
 */
let lastSyncMiniProgramUrl = '';
router.afterEach(() => {
  const wxSdk = window.wx;
  if (!wxSdk || !wxSdk.miniProgram ||
    typeof wxSdk.miniProgram.postMessage != 'function') {
    return;
  }
  const currentUrl = window.location.href.split('#')[0];
  if (currentUrl == lastSyncMiniProgramUrl) {
    return;
  }
  lastSyncMiniProgramUrl = currentUrl;
  try {
    wxSdk.miniProgram.postMessage({ data: { currentUrl: currentUrl } });
  } catch (e) {
    // 非小程序环境或 SDK 未就绪时忽略
  }
});

export default router;
